<template>
<div id="home">
  <my-header></my-header>
  <div class="pd20">
    <!-- <h3>{{'All categories'|translate}}</h3> -->

    <ol class="breadcrumb">
      <li>
        <router-link :to="{ name: 'Home', params: {}}">{{'Home'|translate}}</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'SurveyCertificates', params: {}}">{{'Survey'|translate}}</router-link>
      </li>
      <li class="active" v-if="survey_certificate">{{survey_certificate.name}}</li>
    </ol>

    <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

    <div v-else>
      <p class="mt20 alert alert-info" v-if="list_items.length == 0">{{'There is no question'|translate}}</p>

      <div v-else>
        <h3 v-if="survey_certificate">Bạn đang tự đánh giá theo tiêu chuẩn {{survey_certificate.name}}</h3>
        <p>Vui lòng trả lời {{list_items.length}} câu hỏi bên dưới</p>
        <form v-on:submit.prevent="submitForm">
          <div class="panel panel-info" v-for="(item, index) in list_items" :key="item.id" v-bind:class="{ none : index != curent_position }">
            <div class="panel-heading">
              <h3 class="panel-title">Câu hỏi {{index+1}} : {{item.title}}</h3>
            </div>
            <div class="panel-body">
              <div class="description" v-html="item.description"></div>

              <div v-if="item.control == controls.text">
                <input type="text" class="form-control" placeholder="Câu trả lời của bạn" required v-model="item.value" />
              </div>
              <div v-else-if="item.control == controls.textarea">
                <textarea class="form-control" placeholder="Câu trả lời của bạn" required v-model="item.value"></textarea>
              </div>
              <div v-else-if="item.control == controls.checkbox">
                <div class="row">
                  <div class="col-md-4" v-for="option in item.options" :key="option">
                    <input type="checkbox" :id="option" :value="option" v-model="item.value">
                    <label class="normal" :for="option">{{option}}</label>
                  </div>
                </div>
              </div>
              <div v-else-if="item.control == controls.radio">
                <div class="row">
                  <div class="col-md-4" v-for="option in item.options" :key="option">
                    <input type="radio" required :id="option" :value="option" v-model="item.value">
                    <label class="normal" :for="option">{{option}}</label>
                  </div>
                </div>
                <input type="hidden" required />
              </div>

            </div>
          </div>
          <div class="btn-group" role="group" aria-label="...">
            <button type="button" v-if="curent_position > 0" v-on:click="curent_position--" class="btn btn-default">Trước</button>
            <button type="button" v-if="curent_position < list_items.length-1" v-on:click="setNext" class="btn btn-default">Tiếp theo</button>
            <button type="button" v-on:click="setNext" class="btn btn-primary" v-if="curent_position == list_items.length -1 " :disabled="working"><i v-if="working" class="fas fa-spinner fa-spin"></i> Gửi </button>
          </div>

        </form>
      </div>

    </div>
  </div>
  <!-- <form-store v-if="show_form && all_products.length > 0" ref="formstore" :all_products="all_products" :pass_data="pass_data"  @modalData="modalData"  ></form-store> -->
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
// import FormStore from '@/components/forms/FormStore'

import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      list_items: null,
      page: 1,
      offset: 0,
      survey_certificate_id: null,
      survey_certificate: null,
      keyword: "",
      curent_position: 0,
      working: false,
      controls: {
        text: 1,
        textarea: 2,
        checkbox: 3,
        radio: 4
      }
    };
  },
  methods: {
    setNext() {
      console.log('this.list_items[this.curent_position].value', this.list_items[this.curent_position].value.length);
      if (!this.list_items[this.curent_position].value || this.list_items[this.curent_position].value.length == 0) {
        return Utils.showError(this, "Vui lòng hoàn thành câu hỏi hiện tại");
      }

      if (this.curent_position == this.list_items.length - 1) {
        console.log('ok2');
        this.submitForm();
      } else {
        this.curent_position++;
      }
    },
    submitForm() {
      console.log('submit form here');
      console.log(this.list_items);
      // let map_list = this.list_items.map(item => {
      //   return {
      //     'question_id': item.id,
      //     'answer': item.value,
      //   }
      // });
      let map_answer = {};
      this.list_items.forEach(item => {
        if (item.value) {
          map_answer[item.id] = item.value;
        }
        // map_answer['question_id'] = item.value;
      })

      let post_body = {
        survey_certificate_id: this.survey_certificate_id,
        map_answer: map_answer
      }

      console.log(post_body);
      this.working = true;
      Utils.request(this, true, "survey").post(
          `/submit/`,
          post_body
        ).then(response => {
          let data = response.data;
          if (data.status === "ok") {
            console.log('ok now ');
            Utils.showSuccess(this, "Cảm ơn bạn đã hoàn thành khảo sát");
            // this.curent_position = 0;
            // this.list();
            // redirect to list
            this.$router.push("/survey-certificates");
            // 
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        }).finally(() => {
          this.working = false;
        })

    },
    list() {
      let send_params = {
        survey_certificate_id: this.survey_certificate_id
      }

      Utils.request(this, true, "survey")
        .get(`/questions/?${Utils.arrayToRequestParam(send_params)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.survey_certificate = data.data.survey_certificate;
            let list = data.data.list;
            for (var i = 0; i < list.length; i++) {
              if (list[i].control == this.controls.radio || list[i].control == this.controls.checkbox) {
                list[i].value = [];
              } else {
                list[i].value = '';
              }

              if (list[i].options) {
                let temp = list[i].options.split('\n');
                temp = temp.filter(item => {
                  return item.length > 0
                });
                list[i].options = temp;
              } else {
                list[i].options = [];
              }
            }
            this.list_items = list;
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },

    // certificateDetail() {
    //   Utils.request(this, true, "survey")
    //     .get(`/certificates/${this.survey_certificate_id}`)
    //     .then(response => {
    //       let data = response.data;
    //       if (data.status === "ok") {
    //         this.survey_certificate = data.data;
    //         console.log('this.survey_certificate', this.survey_certificate)
    //       }
    //     })
    //     .catch(error => {
    //       this.updating = false;
    //       Utils.showErrorMessage(this, error.response);
    //     });
    // },

    search() {
      console.log("keyword", this.keyword);
      this.list();
    }
  },
  mounted() {
    this.survey_certificate_id = this.$route.params.survey_certificate_id;
    // this.certificateDetail();
    this.list();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Survey/Questions.vue